<div class="page-head-section">
  <p>Committees</p>
</div>

<div *ngIf="HtmlData" class="Committees">
  <div [innerHTML]="HtmlData"></div>
</div>

<div *ngIf="mainData.length ===0" class="Committees">
  <div class="nodata">No Data found !</div>
</div>
